import React, { Suspense } from 'react';
import { renderRoutes } from 'react-router-config';
import PropTypes from 'prop-types';
import { LinearProgress } from '@material-ui/core';
import styled from 'styled-components/macro';

const Root = styled.div`
  width: 520px;
  margin: 0 auto;
  justify-content: center;
  align-items: center;
  display: flex;
  min-height: 100%;
`;

const Auth: React.FunctionComponent<any> = ({ route }) => {
  return (
    <Root>
      <Suspense fallback={<LinearProgress />}>{renderRoutes(route.routes)}</Suspense>
    </Root>
  );
};

Auth.propTypes = {
  route: PropTypes.object
};

export default Auth;
